import { apiWithToken } from '../api';

const resouceUrl = '/valor_referencia';
const token = localStorage.getItem('@token');
let api = apiWithToken(token);

export const load = async (params) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let page = urlParams.has('page') ? { page: urlParams.get('page') } : {};
  let search = urlParams.has('search')
    ? { search: urlParams.get('search') }
    : {};
  return await api.get(`${resouceUrl}`, {
    params: {
      ...params,
      ...page,
      ...search,
    },
  });
};

export const select = async () => {

  return await api.get(`${resouceUrl}?fields=id,nome&raw_list`);
};

export const show = async (id, params) => {
  return await api.get(`${resouceUrl}/${id}`, {
    params: {
      ...params
    }
  });
}

export const custom_valor_referencia = async (tipo_licenca_id) => {
  return await api.get(`${resouceUrl}/getdata/${tipo_licenca_id}`);
}

export const update = async (id, valor_referencia) => {
  return await api.put(`${resouceUrl}/${id}`, valor_referencia);
}


export const store = async (valor_referencia) => {
  let response = await api.post(`${resouceUrl}/adicionar_valor` , valor_referencia);
  return response;
}

export const destroy = async (id) => {
  return await api.delete(`${resouceUrl}/${id}`);
}

export const activate = async (id) => {
  return await api.post(`${resouceUrl}/${id}/activate`);
}

export const import_data = async (tipo_licenca_id, atividade_id, data_file_csv) => {
  let formData = new FormData();
  formData.append('arquivo', data_file_csv);
  formData.append('tipo_licenca_id', tipo_licenca_id);
  formData.append('atividade_id', atividade_id)

  return await api.post(`${resouceUrl}/import_data`,
    formData,
    tipo_licenca_id,
    atividade_id
    , {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
}
